import ESGScore from'./ESGScore';export default ESGScore;